import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@mzic/mzic-environments';
import {
  CurrencyEnum,
  ExtractedReportDataModel,
  FileOriginTypeEnum,
  GetRoyaltyRunFindParams,
  ReportTypeItem,
  ResponseInterface,
  RevenueTypeItem,
  RoyaltyDto,
  RoyaltyRunApproveData,
  RoyaltyRunListData,
} from '@mzic/mzic-interfaces';
import { Observable } from 'rxjs';
import { httpParams } from './../../../../../mzic-utils/src/lib/helpers/http-params';

@Injectable({
  providedIn: 'root',
})
export class RoyaltyRunResourceService {
  private apiUrl = environment.apiUrl;
  private apiUrlLegacy = environment.apiUrlLegacy;

  constructor(private readonly _http: HttpClient) {}

  getList(params?: GetRoyaltyRunFindParams): Observable<RoyaltyRunListData> {
    return this._http.get<RoyaltyRunListData>(
      `${this.apiUrl}/api/royalty/run/v1/find`,
      {
        ...httpParams(params),
      },
    );
  }

  uploadReport(
    file: File,
    distributor: FileOriginTypeEnum,
    currency: CurrencyEnum | null = null,
  ): Observable<ResponseInterface<ExtractedReportDataModel>> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    return this._http.post<ResponseInterface<ExtractedReportDataModel>>(
      `${this.apiUrlLegacy}/api/royalty/run/v1/upload/report/${distributor}${currency ? '?currency=' + currency : ''}`,
      formData,
    );
  }

  getRoyaltyRunById(id: number): Observable<ResponseInterface<RoyaltyDto>> {
    return this._http.get<ResponseInterface<RoyaltyDto>>(
      `${this.apiUrl}/api/royalty/run/v1/find/detail/${id}`,
    );
  }

  getRevenueTypes(): Observable<ResponseInterface<RevenueTypeItem[]>> {
    return this._http.get<ResponseInterface<RevenueTypeItem[]>>(
      `${this.apiUrl}/api/royalty/run/v1/find/revenue-type`,
    );
  }

  getRevenueTypesByCode(
    revenueType: string,
  ): Observable<ResponseInterface<ReportTypeItem[]>> {
    return this._http.get<ResponseInterface<ReportTypeItem[]>>(
      `${this.apiUrl}/api/royalty/run/v1/find/report-type/${revenueType}`,
    );
  }

  updateName(name: string, id: number): Observable<ResponseInterface<string>> {
    return this._http.patch<ResponseInterface<string>>(
      `${this.apiUrl}/api/royalty/run/v1/update`,
      { name, royaltyId: id },
    );
  }

  approveSplit(
    royaltyRunApprove: RoyaltyRunApproveData,
  ): Observable<ResponseInterface<string>> {
    return this._http.put<ResponseInterface<string>>(
      `${this.apiUrl}/api/royalty/run/v1/approve-split`,
      royaltyRunApprove,
    );
  }
}
